import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@mui/material';
import { Box } from '@mui/system';

import {
  authorColor, authorInitials, getAuthorImageUrl, mergeAuthor,
} from '../../common/ItemTools';
import useAuthorHoverCard from '../AuthorHoverCard';

export default function AuthorAvatar({
  author, name, size, onAuthorView, onAuthorFilter,
}) {
  const merged = author ? mergeAuthor(author) : null;
  const imageUrl = merged ? getAuthorImageUrl(merged, merged.authorImageScope) : null;
  const authorId = author ? author.id : null;
  const canOpen = Boolean(onAuthorView && authorId != null);
  const onCardOpen = canOpen ? () => onAuthorView(authorId) : undefined;
  const onCardFilter = authorId != null && onAuthorFilter
    ? () => onAuthorFilter(authorId)
    : undefined;
  const { triggerProps, popper, close } = useAuthorHoverCard(author, {
    onCardOpen,
    onCardFilter,
    placement: 'bottom-start',
  });
  const handleClick = canOpen
    ? (e) => { e.stopPropagation(); close(); onAuthorView(authorId); }
    : undefined;

  const commonSx = {
    width: size,
    height: size,
    border: '2px solid #fff',
    marginLeft: '-8px',
    flexShrink: 0,
    cursor: canOpen ? 'pointer' : 'default',
  };

  return (
    <>
      {imageUrl ? (
        <Avatar
          src={imageUrl}
          alt={name}
          {...triggerProps}
          onClick={handleClick}
          sx={commonSx}
        />
      ) : (
        <Box
          {...triggerProps}
          onClick={handleClick}
          sx={{
            ...commonSx,
            borderRadius: '50%',
            background: authorColor(name),
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size <= 30 ? 11 : 12,
            fontWeight: 700,
            boxSizing: 'border-box',
          }}
        >
          {authorInitials(name)}
        </Box>
      )}
      {popper}
    </>
  );
}

AuthorAvatar.propTypes = {
  author: PropTypes.object,
  name: PropTypes.string,
  size: PropTypes.number,
  onAuthorView: PropTypes.func,
  onAuthorFilter: PropTypes.func,
};

AuthorAvatar.defaultProps = {
  author: null,
  name: '',
  size: 32,
  onAuthorView: null,
  onAuthorFilter: null,
};
